export const booklist = {
  isDomestic: '국내 도서',
  category: '건강/취미',
  topic: '공예',
  bookList: [
    {
      BookId: 1,
      title: '도서 제목이 길어졌을 경우의 도서 제목',
      author: '작가명',
      publisher: '출판사명',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      isDomestic: '국내 도서',
      category: '건강/취미',
      topic: '공예',
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
    {
      BookId: 2,
      title: '도서 제목2',
      author: '작가명',
      publisher: '출판사명',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      isDomestic: '국내 도서',
      category: '건강/취미',
      topic: '공예',
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
    {
      BookId: 3,
      title: '도서 제목3',
      author: '작가명',
      publisher: '출판사명',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      isDomestic: '국내 도서',
      category: '건강/취미',
      topic: '공예',
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
  ],
};

export const recordlist = {
  category: '가요',
  topic: '뉴에이지',
  recordList: [
    {
      recordId: 1,
      title: '음반명1',
      singer: '가수명',
      publisher: '발매사',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
    {
      recordId: 2,
      title: '음반명2',
      singer: '가수명',
      publisher: '발매사',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
    {
      recordId: 3,
      title: '음반명3',
      singer: '가수명',
      publisher: '발매사',
      price: 13000,
      lowestPrice: 7000,
      stock: 3,
      location: 'A17',
      refImage: 'https://s3.ap-northeast-2.amazonaws.com/dd/pdd/image/d953fdec-b85f-4ce9-b7f5-7a',
    },
  ],
};

export const goodslist = {
  goodsList: [
    {
      goods_id: 1,
      goods_name: '스누피 안경',
      price: 10000,
      stock: 100,
      location: 'A19',
      ref_image: 'https://aladins-toy1.s3.ap-northeast-2.amazonaws.com',
    },
    {
      goods_id: 2,
      goods_name: '에어팟 케이스',
      price: 10000,
      stock: 50,
      location: 'A12',
      ref_image: 'https://aladins-toy1.s3.ap-northeast-2.amazonaws.com',
    },
  ],
};
